import { parseWorkoutNumber } from "@/lib/fitness/workoutNumber";
import { useEffect, useRef, useState } from 'react';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function WorkoutNumberInput({ label, value, onChange, onValidityChange, min, max, integer = false, disabled = false }: {
  label: string; value: number; onChange: (value: number) => void; onValidityChange?: (valid: boolean) => void;
  min: number; max: number; integer?: boolean; disabled?: boolean;
}) {
  const { t } = useLanguage();
  const [draft, setDraft] = useState(String(value));
  const input = useRef<HTMLInputElement>(null), validity = useRef(onValidityChange);
  validity.current = onValidityChange;
  useEffect(() => {
    if (document.activeElement !== input.current) { setDraft(String(value)); validity.current?.(parseWorkoutNumber(String(value), min, max, integer) !== null); }
  }, [value, min, max, integer]);
  const valid = parseWorkoutNumber(draft, min, max, integer) !== null;
  return <label className="block min-w-0">
    <span className="mb-1.5 block text-xs text-muted-foreground">{label}</span>
    <input ref={input} type="text" inputMode={integer ? 'numeric' : 'decimal'} disabled={disabled}
      value={draft} aria-invalid={!valid} className="min-h-12 w-full rounded-xl border border-border bg-background px-3 py-2 text-lg font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50"
      onChange={event => {
        const raw = event.target.value; setDraft(raw);
        const next = parseWorkoutNumber(raw, min, max, integer);
        validity.current?.(next !== null); if (next !== null) onChange(next);
      }} />
    {!valid && <span role="alert" className="mt-1 block text-xs text-destructive">{t('fitness.builder.invalidNumber')}</span>}
  </label>;
}
